import axios from './axios';
import { getToken } from './authService';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/vouchers`;

export const getVouchers = async (settlement_date_id) => {
  const token = getToken();
  const params = settlement_date_id ? { date: settlement_date_id } : {};
  const res = await axios.get(API_URL, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return res.data;
};


export const importVouchers = async (data) => {
  const token = getToken();
  const res = await axios.post(API_URL + '/import', data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// Bulk delete vouchers
export const deleteVouchers = async (ids) => {
  const token = getToken();
  const res = await axios.post(API_URL + '/bulk-delete', { ids }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

const DELETE_BATCH_SIZE = 250;

/** Bulk-delete in chunks to avoid oversized request bodies. */
export const deleteVouchersInBatches = async (ids, batchSize = DELETE_BATCH_SIZE) => {
  const list = [...new Set(ids.map((id) => Number(id)).filter((n) => Number.isInteger(n) && n > 0))];
  if (list.length === 0) return { deleted: [] };
  const allDeleted = [];
  for (let i = 0; i < list.length; i += batchSize) {
    const slice = list.slice(i, i + batchSize);
    const { deleted } = await deleteVouchers(slice);
    if (Array.isArray(deleted)) allDeleted.push(...deleted);
  }
  return { deleted: allDeleted };
};
